import { ReactNode } from 'react';
import { AlertCircle, CheckCircle, Info } from 'lucide-react';

type Variant = 'error' | 'success' | 'info';

const STYLES: Record<Variant, { bg: string; border: string; color: string; Icon: typeof Info }> = {
  error: { bg: 'rgba(239,68,68,0.12)', border: 'rgba(239,68,68,0.3)', color: '#EF4444', Icon: AlertCircle },
  success: { bg: 'rgba(34,197,94,0.12)', border: 'rgba(34,197,94,0.3)', color: '#22C55E', Icon: CheckCircle },
  info: { bg: 'rgba(251,58,174,0.12)', border: 'rgba(251,58,174,0.3)', color: '#FB3AAE', Icon: Info },
};

export function AuthAlert({ variant = 'error', children }: { variant?: Variant; children: ReactNode }) {
  const s = STYLES[variant];
  return (
    <div
      className="flex items-start gap-2.5 rounded-2xl px-4 py-3"
      style={{ backgroundColor: s.bg, border: `1px solid ${s.border}` }}
      role="alert"
    >
      <s.Icon size={18} style={{ color: s.color }} className="shrink-0 mt-0.5" />
      <p style={{ color: s.color }} className="text-sm leading-snug">
        {children}
      </p>
    </div>
  );
}
